import React from "react";
import PropTypes from "prop-types";

import WithFullWidthFlyouts from "@/components/layout-blocks/navbar/with-full-width-flyouts";
import FourColumnWithAddress from "@/components/layout-blocks/footer/four-column-with-address";

function Layout({
  layoutData,
  locale,
  languageLinks,
  switchBackground = true,
  children,
}) {
  return (
    <div className="flex min-h-screen flex-col">
      <WithFullWidthFlyouts
        data={
          layoutData?.componentsObject
            ?.StrapiComponentNavbarWithFullWidthFlyouts
        }
        locale={locale}
        languageLinks={languageLinks}
        switchBackground={switchBackground}
      />
      <div className="grow">{children}</div>
      <FourColumnWithAddress
        data={
          layoutData?.componentsObject
            ?.StrapiComponentFooterFourColumnWithAddress
        }
        locale={locale}
        className="shrink-0"
      />
    </div>
  );
}

Layout.propTypes = {
  layoutData: PropTypes.object,
  locale: PropTypes.string,
  languageLinks: PropTypes.object,
  location: PropTypes.object,
  children: PropTypes.node,
};

export default Layout;
